import { CreateButton, List, useTable } from "@refinedev/antd";
import { Button, Space, Table, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router";

import { DATE_TIME_FORMAT } from "../labels";
import type { BlogPostListItem } from "../types";

export function postStatusTag(post: Pick<BlogPostListItem, "status" | "isLive" | "isScheduled">) {
  if (post.isLive) return <Tag color="green">Yayında</Tag>;
  if (post.isScheduled) return <Tag color="blue">Planlandı</Tag>;
  return <Tag>Taslak</Tag>;
}

/**
 * /blog (permission `blog.manage`; product decision 2026-10-10): every post, the latest change
 * first. A row opens the editor; authors and categories have their own pages.
 */
export function BlogPostsPage() {
  const navigate = useNavigate();
  const { tableProps } = useTable<BlogPostListItem>({
    resource: "blog/posts",
    pagination: { mode: "off" },
    syncWithLocation: false,
  });

  return (
    <List
      title="Blog"
      headerButtons={
        <Space wrap>
          <Button onClick={() => navigate("/blog/authors")}>Yazarlar</Button>
          <Button onClick={() => navigate("/blog/categories")}>Kategoriler</Button>
          <CreateButton onClick={() => navigate("/blog/new")}>Yeni yazı</CreateButton>
        </Space>
      }
    >
      <Table
        {...tableProps}
        rowKey="id"
        pagination={false}
        scroll={{ x: "max-content" }}
        locale={{ emptyText: "Henüz yazı yok." }}
        onRow={(post) => ({
          onClick: () => navigate(`/blog/${post.id}`),
          style: { cursor: "pointer" },
        })}
      >
        <Table.Column<BlogPostListItem>
          title="Başlık"
          dataIndex="title"
          render={(title: string, post) => (
            <Space direction="vertical" size={0}>
              <Typography.Text strong>{title}</Typography.Text>
              <Typography.Text type="secondary">/blog/{post.slug}</Typography.Text>
            </Space>
          )}
        />
        <Table.Column<BlogPostListItem>
          title="Durum"
          render={(_, post) => (
            <Space>
              {postStatusTag(post)}
              {post.noindex ? <Tag color="orange">Aramada gizli</Tag> : null}
            </Space>
          )}
        />
        <Table.Column<BlogPostListItem>
          title="Yayın tarihi"
          dataIndex="publishedAt"
          render={(value: string | null) => (value ? dayjs(value).format(DATE_TIME_FORMAT) : "—")}
        />
        <Table.Column<BlogPostListItem>
          title="Kategori"
          render={(_, post) => post.category?.name ?? "—"}
        />
        <Table.Column<BlogPostListItem> title="Yazar" render={(_, post) => post.author.name} />
        <Table.Column<BlogPostListItem> title="Kelime" dataIndex="wordCount" />
        <Table.Column<BlogPostListItem>
          title="Son değişiklik"
          dataIndex="updatedAt"
          render={(value: string) => dayjs(value).format(DATE_TIME_FORMAT)}
        />
      </Table>
    </List>
  );
}
